// src/utils/contentTypeUtils.js
export const buildContentTypeOptions = (
    allContentTypes,
    permittedContentTypes,
    orgIntegrationData
) => {
    const INTEGRATION_TYPE_NAMES = ["Machine Metrics", "Acumatica", "Power BI"];

    const safeContentTypes = allContentTypes || [];
    const safePermittedTypes = permittedContentTypes || [];
    const safeIntegrations = orgIntegrationData || [];

    const isIntegrationActive = (name) =>
        safeIntegrations.some(
            (item) =>
                item.integration_name === name &&
                item.ic_activeflag === 1 &&
                item.ic_integration_flag === 1
        );

    // Create valid content type map from master list
    const contentTypeMap = new Map(
        safeContentTypes.map((ct) => [
            ct.ic_content_type_id,
            ct.ic_content_type_name,
        ])
    );

    // Only allow permitted IDs that actually exist in allContentTypes
    const permittedIds = new Set(
        safePermittedTypes
            .filter(
                (p) =>
                    contentTypeMap.has(p.ic_content_type_id) &&
                    contentTypeMap.get(p.ic_content_type_id) ===
                        p.ic_content_type_name
            )
            .map((p) => p.ic_content_type_id)
    );

    const permitted = [];
    const restricted = [];

    safeContentTypes.forEach((ct) => {
        const isPermitted = permittedIds.has(ct.ic_content_type_id);

        const isIntegrationType = INTEGRATION_TYPE_NAMES.includes(
            ct.ic_content_type_name
        );

        const integrationOk = isIntegrationType
            ? isIntegrationActive(ct.ic_content_type_name)
            : true;

        const isSelectable = isPermitted && integrationOk;

        const option = {
            label: ct.ic_content_type_name,
            disabled: !isSelectable,
            ic_content_type_id: ct.ic_content_type_id,
        };

        if (isSelectable) {
            permitted.push(option);
        } else {
            restricted.push(option);
        }
    });

    return [...permitted, ...restricted];
};